export function numberWithCommas(
  x: number,
  dp: number = 2,
  fallback: string = ""
) {
  if (x === undefined || x === null) {
    return fallback;
  }
  return x
    .toFixed(dp)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function fixBillion(x: string) {
  return x.replace("B", "bn");
}

export function marketCap(
  x: number | null
) {
  if (x === undefined || x === null) {
    return "-";
  }

  return fixBillion(compactNumber((x / 100), "-", true))
}

export function compactNumber(
  x: number | null,
  fallback: string = "-",
  currency: boolean = false
) {
  if (x === undefined || x === null) {
    return fallback;
  }
  try {
    if (currency) {
      return new Intl.NumberFormat('en', {
        notation: 'compact',
        style: 'currency',
        currency: 'GBP',
        roundingPriority: 'morePrecision',
        maximumSignificantDigits: 3
      }).format(x)
    }

    return new Intl.NumberFormat('en', {notation: 'compact'}).format(x)
  } catch (e) {
    console.log(e);
    return fallback;
  }
}

export function currency(x: number) {
  if (!x) {
    return "";
  }
  const price = numberWithCommas(x / 100)

  return price.startsWith("-") ? `-£${price.split("-")[1]}` : `£${price}`
}

export function percentage(x: number) {
  if (!Number.isFinite(x)) {
    return "";
  }
  return x.toFixed(2) + "%";
}

export function share(x?: number) {
  if (x === undefined) {
    return "";
  }
  return x.toFixed(2);
}
